import FeatureGates from '@atlaskit/feature-gate-js-client/feature-gates';

export const CONTENT_REVIEWER_AGENT_CONFIG = 'platform_editor_ai_content_reviewer_agent_config';

const AGENT_ID_PARAMETER = 'value';

/**
 * Returns the custom Content Reviewer agent selected by Statsig.
 *
 * An absent or invalid value intentionally falls back to the existing OOTB agent resolution path.
 */
export function getConfiguredContentReviewerAgentId(): string | undefined {
	try {
		if (!FeatureGates.initializeCompleted()) {
			return undefined;
		}

		const agentId = FeatureGates.getExperiment(CONTENT_REVIEWER_AGENT_CONFIG).get(
			AGENT_ID_PARAMETER,
			'',
		);
		const normalizedAgentId = agentId.trim();

		return normalizedAgentId || undefined;
	} catch {
		return undefined;
	}
}
